import { render, staticRenderFns } from "./RegSearchPage.vue?vue&type=template&id=03b32ff2"
import script from "./RegSearchPage.vue?vue&type=script&lang=js"
export * from "./RegSearchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports